<template>
    <div class="story-maker-sticker story-maker-sticker-location">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div 
            class="sticker-location" 
            :class="`style${stickerInstance.data.styleVariant}`"
            @click="stickerInstance.nextStyleVariant"
        >
           <div class="icon"></div>
            <p>{{ stickerInstance.data.place.name ? stickerInstance.data.place.name : '' }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            stickerInstance: {
                type: Object,
                required: true
            }
        },
    }
</script>
